import { CountryRepository } from '@/domain/country/CountryRepository';
import { AxiosInstance } from 'axios';
import { NotFound } from '@/domain/NotFound';
import { StaticFileCountryTopology, toCountryFeatureCollection } from '@/secondary/country/StaticFileCountryTopology';
import { GeoJSON } from 'ol/format';
import { Country } from '@/domain/country/Country';

export class StaticFileCountryRepository implements CountryRepository {
  constructor(private axiosInstance: AxiosInstance) {}

  list(): Promise<GeoJSON.FeatureCollection<GeoJSON.MultiPolygon, Country>> {
    return this.axiosInstance
      .get<StaticFileCountryTopology>('countries.topojson')
      .then(response => toCountryFeatureCollection(response.data))
      .catch(error => {
        throw new NotFound('Countries topojson').cause(error);
      });
  }
}
